import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import CreatePricelist from "./CreatePricelist.graphql";

export default function useCreatePricelist() {
    return useMutation(gql(CreatePricelist));
}
